import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LocalTranslateService {
  private currentLanguage: string;


  constructor(private translate: TranslateService) {
    translate.addLangs(['brand_1', 'brand_2', 'brand_3']);
    translate.setDefaultLang('brand_1');
    this.currentLanguage = 'brand_1';
  }

  setCurrentLang(storeId: number) {
    this.currentLanguage = 'brand_' + storeId;

    this.translate.use(this.currentLanguage);
  }

  getCurrentLang() {
    return this.currentLanguage;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/local_translate.service.ts